import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {errorInterceptor} from "./security/error.interceptor";
import {loadingInterceptor} from "./security/loading.interceptor";
import {AuthInterceptor} from "./security/auth.interceptor";
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppUpdateService } from './services/app-update.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([
        loadingInterceptor,
        errorInterceptor
      ])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppUpdateService],
      useFactory: (updateService: AppUpdateService) => () => updateService.initialize(),
    },
  ]
};
